import React, { useEffect } from 'react'
import Script from 'next/script'

import { Wrapper } from './styles'
import { WistiaVideo } from './global'

interface Props {
  id: string
  time?: number
}

export const VideoPlayer: React.FC<Props> = ({ id, time }) => {
  const videoRef = React.useRef<WistiaVideo | null>(null)

  useEffect(() => {
    videoRef.current?.time(time ?? 0)
  }, [time])

  return (
    <>
      <Script
        id="wistia"
        key="wistia"
        src="//fast.wistia.com/assets/external/E-v1.js"
        onLoad={() => {
          window._wq = window._wq || []
          window._wq.push({
            id,
            options: {
              videoFoam: false,
            },
            onReady: (video) => {
              videoRef.current = video
            },
          })
        }}
      />
      <Wrapper className={`wistia_embed wistia_async_${id}`} />
    </>
  )
}

export default VideoPlayer
